import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import { useSessionsByUserId } from '../api/SessionsAPI';
import { SessionStatus } from '../constants/enum';

const SessionContext = createContext(null);

export const useSession = () => useContext(SessionContext);

export const SessionProvider = ({ children }) => {
    const [sessionId, setSessionIdState] = useState(null);
    const { currentUser } = useAuth();
        
    // Use the React Query hook to fetch sessions
    const { data: sessions, isLoading } = useSessionsByUserId(currentUser?.id);
    
    
    const setSessionId = (id) => {
        setSessionIdState(id);
    };
    
    useEffect(() => {
        
        // When sessions data is loaded, find the in-progress session
        if (sessions && !isLoading) {
            const inProgressSession = sessions.find(
                session => session.status === SessionStatus.IN_PROGRESS
            );
            
            console.log('[SessionContext] In-progress session found:', inProgressSession);
            
            if (inProgressSession) {
                // Use the first in-progress session found
                setSessionId(inProgressSession.id);
            } else {
                // No valid session found
                console.log('[SessionContext] No in-progress session found');
                setSessionId(null);
            }
        }
    }, [sessions, isLoading, currentUser]);

    console.log('[SessionContext] Rendering with sessionId:', sessionId);

    return (
        <SessionContext.Provider value={{ sessionId, setSessionId }}>
            {children}
        </SessionContext.Provider>
    );
};